import * as React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { FluentProvider } from "@fluentui/react-components";
import { AuthProvider } from "./auth/AuthProvider";
import { TenantProvider } from "./auth/TenantContext";
import { primerDarkTheme } from "./styles/primerDarkTheme";
import App from "./App";
import DebugAuth from "./auth/DebugAuth";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
        <BrowserRouter>
            <Routes>
                <Route path="/auth-debug" element={<DebugAuth />} />
                <Route path="/*" element={
                    <AuthProvider>
                        <TenantProvider>
                            <FluentProvider theme={primerDarkTheme}>
                                <App />
                            </FluentProvider>
                        </TenantProvider>
                    </AuthProvider>
                } />
            </Routes>
        </BrowserRouter>
    </React.StrictMode>,
);
